import api from '../api';

import { ParamsPersonalCardByPlatform } from 'utils/typeServices';

type ParamsReponse = {
    Data: ParamsPersonalCardByPlatform;
}

export const GetCustomerCard = async ({ token, platformId }: { token: string, platformId: number }) => {
    try {
        const { data } = await api.get<ParamsReponse>(`v1/Plataforma/GetCustomerPersonalCardByPlatform/${platformId}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
